import { FaFileExcel } from "react-icons/fa";

export default function ExportButton(props) {
    return (
        <button className="export-button" {...props}>
            <FaFileExcel /> Export
        </button>
    );
}
